module.exports = __webpack_public_path__ + "img/11.5940e554.png";